
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investment-opportunities",
      function () {
        return require("private-next-pages/investment-opportunities/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investment-opportunities"])
      });
    }
  